module.exports = __webpack_public_path__ + "img/guardian_buff_sacredflame.75d643af.png";